import React from "react";
import { useDispatch } from "react-redux";
import { createLinkAssetRequest } from "src/redux/actions/assets";

import cx from "classnames";
import { Input } from "src/components/input";

import { fixHTTPUrl, isUrlValid } from "src/services/util";
import styles from "./links.module.scss";
import { nanoid } from "nanoid";

interface AddUrlAssetProps {
  onCreate: () => void
}

const AddUrlAsset: React.FC<AddUrlAssetProps> = ({ onCreate }) => {
  const dispatch = useDispatch();

  const [url, setUrl] = React.useState<string>("");
  const [showErrorMessage, setShowErrorMessage] = React.useState<boolean>(false);

  const handleUrlChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setShowErrorMessage(false);
    setUrl(e.target.value);
  };

  const handleClick = (e: React.FormEvent) => {
    e.preventDefault();
    
    const trimmedURL = url.trim();
    const fixedURl = fixHTTPUrl(trimmedURL)
    
    if (!isUrlValid(fixedURl)) {
      setShowErrorMessage(true);
    } else {
      dispatch(createLinkAssetRequest({
        id: nanoid(),
        url: fixedURl
      }));

      setUrl('');
      setShowErrorMessage(false);

      onCreate();
    }
  };

  return (
    <form className={styles.container} onSubmit={handleClick}>
      <Input
        placeholder="The web is your oyster. Paste URL here!"
        value={url}
        onChange={handleUrlChange}
        className={styles.urlInput}
      />
      <i
        onClick={handleClick}
        className={cx("paperflite-right-arrow", styles.icon, {
          [styles.showIcon]: url,
        })}
      />

      {showErrorMessage && (
        <span className={styles.warningMessage}>
          <i className="paperflite-danger" />
          Please enter a valid URL
        </span>
      )}
    </form>
  );
};

export default AddUrlAsset;
